import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminSidebarGroup from './AdminSidebarGroup';
import { useAdminDashboardMetrics } from '../../hooks/useAdminDashboardMetrics';

/**
 * Configuración del menú admin agrupado. Badges se inyectan desde useAdminDashboardMetrics.
 */
function getMenuConfig(metrics) {
  const { solicitudesPendientes = 0, solicitudesConMatch = 0, empresasPorVerificar = 0 } = metrics;
  return [
    {
      title: 'Operación',
      defaultOpen: true,
      items: [
        { to: 'solicitudes-registro', label: 'Solicitudes de Registro', icon: '📋', badge: solicitudesPendientes },
        { to: 'solicitudes-registro', label: 'Solicitudes con coincidencias', icon: '🔗', badge: solicitudesConMatch },
        { to: 'validacion-clientes', label: 'Validaciones', icon: '✅' },
        { to: 'solicitudes-acceso-dashboard', label: 'Acceso Dashboard', icon: '🔑', badge: metrics.solicitudesAccesoPendientes || 0 }
      ]
    },
    {
      title: 'Directorio',
      defaultOpen: true,
      items: [
        { to: 'empresas', label: 'Listado de empresas', icon: '🏢', badge: empresasPorVerificar },
        { to: 'directorio/metricas', label: 'Métricas y números', icon: '📊' },
        { to: 'directorio/zonas', label: 'Zonas y comunas', icon: '🗺️' },
        { to: 'empresas?vista=repetidas', label: 'Empresas repetidas', icon: '🧬' },
        { to: 'clientes-kawescar', label: 'Clientes', icon: '👥' },
        { to: 'clientes-premium-promo', label: 'Beneficiados Premium', icon: '🎁' }
      ]
    },
    {
      title: 'Catálogo',
      defaultOpen: true,
      items: [
        { to: 'productos', label: 'Productos', icon: '📦' },
        { to: 'campanas', label: 'Campañas', icon: '📢' }
      ]
    },
    {
      title: 'Finanzas',
      defaultOpen: true,
      items: [
        { to: 'pagos-membresias', label: 'Membresías', icon: '💳' },
        { to: 'traspasos-vehiculos', label: 'Traspasos y asignación', icon: '🔄' },
      ]
    },
    {
      title: 'Plataforma',
      defaultOpen: false,
      items: [
        { to: 'tips', label: 'Tips (mantenedor)', icon: '🧠' },
        { to: 'peajes', label: 'Peajes Chile', icon: '🛣️' },
        { to: 'gestion-contenido', label: 'Gestión de contenido', icon: '📝' },
        { to: 'recursos-educativos', label: 'Recursos educativos', icon: '📚' },
        { to: 'estadisticas', label: 'Métricas', icon: '📊' },
        { to: 'audiencia-actividad', label: 'Audiencia y actividad', icon: '📈' },
        { to: 'metricas-busqueda', label: 'Métricas de búsqueda', icon: '🔍' }
      ]
    },
    {
      title: 'Seguridad',
      defaultOpen: false,
      items: [
        { to: 'gestion-agentes', label: 'Agentes y Roles', icon: '👤' },
        { to: 'administradores', label: 'Administradores', icon: '🛡️' },
        { to: '#', label: 'Auditoría', icon: '📋' } // placeholder
      ]
    }
  ];
}

export default function AdminSidebar({ onNavigate }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { metrics } = useAdminDashboardMetrics();
  const menuConfig = getMenuConfig(metrics);

  const handleNav = (to) => {
    if (to && to !== '#') navigate(to.startsWith('/') ? to : `/admin/${to}`);
    if (onNavigate) onNavigate();
  };

  return (
    <aside className="w-[260px] flex-shrink-0 bg-slate-900 text-white min-h-screen flex flex-col overflow-y-auto">
      <div className="p-4 border-b border-slate-700">
        <button
          type="button"
          onClick={() => handleNav('/admin')}
          className="flex items-center gap-2 w-full text-left"
        >
          <span className="text-xl">🚗</span>
          <div>
            <div className="font-bold tracking-wide">KawesCar</div>
            <div className="text-xs text-slate-400">Administración</div>
          </div>
        </button>
      </div>
      <nav className="flex-1 py-2">
        <div className="mb-2">
          <button
            type="button"
            onClick={() => handleNav('/admin')}
            className={`w-full flex items-center gap-2 px-4 py-2.5 text-left text-sm ${
              location.pathname === '/admin' ? 'bg-slate-700 text-white' : 'text-slate-300 hover:bg-slate-800'
            }`}
          >
            <span>🏠</span>
            <span>Panel Principal</span>
          </button>
        </div>
        {menuConfig.map((group) => (
          <AdminSidebarGroup
            key={group.title}
            title={group.title}
            items={group.items}
            defaultOpen={group.defaultOpen}
            onItemClick={onNavigate}
          />
        ))}
      </nav>
    </aside>
  );
}
